import clearfix from './clearfix';
import { css } from 'styled-components';
import { MaxWidth } from '../constants';

const row = css`
    ${clearfix}

    margin-left: auto;
    margin-right: auto;
    max-width: ${MaxWidth}px;
`;

export default row;
